'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../../common/providers/ClaimBuilder/index.js');
var SessionContext = require('../../../../common/providers/SessionContext.js');
var useAnalytics = require('../../../../common/providers/useAnalytics.js');
var ItemClaimSummaryProvider = require('../../../../common/views/ClaimSummary/item/ItemClaimSummaryProvider.js');
var ItemClaimSummaryViewRoot = require('../../../../common/views/ClaimSummary/item/ItemClaimSummaryViewRoot.js');
var ClaimSummaryViewContainer = require('./components/ClaimSummaryViewContainer.js');
var ClaimSummaryHeader = require('./components/ClaimSummaryHeader.js');
var ItemClaimSummaryDetails = require('../../../../common/views/ClaimSummary/item/ItemClaimSummaryDetails.js');
var ClaimSummarySignature = require('./components/ClaimSummarySignature.js');
var useCreateClaimMutation = require('./useCreateClaimMutation.js');
var ClaimSummaryAppeasement = require('../../../../common/views/ClaimSummary/components/ClaimSummaryAppeasement.js');
var ClaimSummarySection = require('../../../../common/views/ClaimSummary/components/ClaimSummarySection.js');
var ClaimSummarySectionHeader = require('./components/ClaimSummarySectionHeader.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookSettings = require('@narvar/nth-hook-settings');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemClaimSummary = () => {
  const {
    claimsSummaryItemSubtitle,
    claimsSummaryAppeasementTitle
  } = nthHookTranslations.useTranslations();
  const {
    claimAppeasements
  } = nthHookSettings.useSettings();
  const {
    state: {
      claimType
    }
  } = index.useClaimBuilder();
  const [signature, setSignature] = React.useState('');
  const [confirmationChecked, setConfirmationChecked] = React.useState(false);
  const {
    orderNumber
  } = SessionContext.useSession();
  const logEvent = useAnalytics["default"]();
  const {
    submitClaimStatus,
    onBack,
    onSubmit,
    appeasement,
    setAppeasement
  } = ItemClaimSummaryProvider.useItemClaimSummary();
  const handleSignatureChange = e => {
    setSignature(e.target.value);
  };
  const handleConfirmationChange = e => {
    if (e.target.checked) {
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.REVIEW_CONFIRMATION_CHECKED,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_CLAIM_SUMMARY,
        order_number: orderNumber,
        claim_reason: claimType,
        page_step: useAnalytics.ClaimsPageStep.REVIEW_SUBMIT
      });
    }
    setConfirmationChecked(e.target.checked);
  };
  return /*#__PURE__*/React__default["default"].createElement(ClaimSummaryViewContainer["default"], {
    onBackClick: onBack,
    onNextClick: onSubmit,
    signature: signature,
    confirmationChecked: confirmationChecked,
    submitClaimStatus: submitClaimStatus
  }, /*#__PURE__*/React__default["default"].createElement(ClaimSummaryHeader["default"], {
    submitClaimStatus: submitClaimStatus
  }), /*#__PURE__*/React__default["default"].createElement(ClaimSummarySection["default"], null, /*#__PURE__*/React__default["default"].createElement(ClaimSummarySectionHeader["default"], null, claimsSummaryItemSubtitle), /*#__PURE__*/React__default["default"].createElement(ItemClaimSummaryDetails["default"], null)), (claimAppeasements === null || claimAppeasements === void 0 ? void 0 : claimAppeasements.enabled) && /*#__PURE__*/React__default["default"].createElement(ClaimSummarySection["default"], null, /*#__PURE__*/React__default["default"].createElement(ClaimSummarySectionHeader["default"], null, claimsSummaryAppeasementTitle), /*#__PURE__*/React__default["default"].createElement(ClaimSummaryAppeasement["default"], {
    appeasement: appeasement,
    setAppeasement: setAppeasement
  })), /*#__PURE__*/React__default["default"].createElement(ClaimSummarySignature["default"], {
    signatureOnChange: handleSignatureChange,
    signatureValue: signature,
    confirmationChecked: confirmationChecked,
    confirmationOnChange: handleConfirmationChange
  }));
};
const ItemClaimSummaryWithViewRoot = () => /*#__PURE__*/React__default["default"].createElement(ItemClaimSummaryViewRoot["default"], {
  useCreateClaimMutation: useCreateClaimMutation["default"]
}, /*#__PURE__*/React__default["default"].createElement(ItemClaimSummary, null));
var ItemClaimSummary$1 = nthHookTranslations.withTranslationsProvider(nthHookSettings.withSettingsProvider(ItemClaimSummaryWithViewRoot, {
  settingsRequested: `
    claimAppeasements {
      enabled
    }
  `
}), {
  translationKeys: ['claimsSummaryItemSubtitle', 'claimsSummaryAppeasementTitle']
});

exports["default"] = ItemClaimSummary$1;
